import { Page, QueryBase } from "../../shared/models/models";

export interface Lead {
  email: string;
  createdDate: string;
}

export interface AdminLeadsState {
  query: LeadsQuery;
  leads?: Page<Lead>;
  loading: boolean;
  success?: string;
  error: any;
}

export interface LeadsQuery extends QueryBase<LeadsQueryParameter> {
}

export enum LeadsQueryParameter {
  createdDate = 1
}
